import {$dom} from "./helpers/dom";
import Page from "./classes/Page";
import components from "./pages/service/_components";

$dom.ready(function() {
    this.currentPage = new Page({
        name: 'landingService',
        rootElementId: 'js-page-landing-service'
    });

    this.currentPage.init(components(this.currentPage));
});